export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6867.5c892b07.jpg";